/**
 * Returns true when a keyboard event belongs to an in-progress IME
 * composition (e.g. Japanese kana→kanji conversion). Enter pressed to commit
 * the conversion must not be treated as a regular submission.
 */
export const isImeComposition = (event: KeyboardEvent): boolean =>
  event.isComposing || event.keyCode === 229
